import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from '@/lib/api';

export interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
  icon: string;
  image_url: string;
  order_index: number;
  animals_count: number;
}

async function fetchCategories(): Promise<Category[]> {
  const { data } = await api.get<Category[]>('/api/categories');
  return data;
}

export function useCategories() {
  const { i18n } = useTranslation();
  // Include lang in queryKey so cache is invalidated on language switch
  const lang = i18n.language?.startsWith('en') ? 'en' : 'ru';

  return useQuery({
    queryKey: ['categories', lang],
    queryFn: fetchCategories,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
